export default "__VITE_ASSET__8bxl6m6V__"